export default __webpack_public_path__ + "static/media/sassBW.c5e78bb3.webp";